// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1nkHC","savePackageButton":"ClientWallet_savePackageButton__2LqJY"};